import { render, staticRenderFns } from "./AgxLinkList.vue?vue&type=template&id=372afb36&"
import script from "./AgxLinkList.vue?vue&type=script&lang=js&"
export * from "./AgxLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports